import { GET_HOUSING_LIST_API_ENDPOINT } from '@/constants';
import { IHousingListResponse, SearchListFilters } from '@/types';
import { getAcceptLanguageHeader, type Locale } from '@/config/i18n/locales';
import { fetchWithAuth } from '@/lib/fetchWithAuth';
import { withServerTiming } from '@/lib/serverTiming';
import { logSsrFetch } from '@/lib/ssrLog';

export const fetchHousingListSsr = async (
  searchObj: SearchListFilters,
  locale?: Locale,
): Promise<IHousingListResponse | null> =>
  withServerTiming('fetchHousingListSsr', async () => {
    try {
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      if (locale) headers['Accept-Language'] = getAcceptLanguageHeader(locale);

      const url = `${process.env.NEXT_PUBLIC_API_URL}${GET_HOUSING_LIST_API_ENDPOINT}`;
      const { res, auth, ms } = await fetchWithAuth(url, {
        method: 'POST',
        cache: 'no-store',
        headers,
        body: JSON.stringify(searchObj),
      });
      logSsrFetch({ url, timing: ms, status: res.status, auth });

      if (!res.ok) return null;
      return (await res.json()) as IHousingListResponse;
    } catch (err) {
      console.error('fetchHousingListSsr ERROR:', err);
      return null;
    }
  });
